export const cloudIncidentsDeprecatedRouteMap = {
  "/known-issues": "/cloud-incidents",
  "/known-issues/:knownIssueId": "/cloud-incidents/:knownIssueId",
};
